//* Libraries imports
import { useQuery } from "@tanstack/react-query";

//* Schemas Import
import { fullEssay } from "../../../schemas/common/essay/essay";

//* Axios Import
import { privateApi } from "../../../services/apis/configs/apiClient";

//* Zod Import
import { z } from "zod";

const essayDetailResponseSchema = z.any()
const EssayAPI = {
  getById: async function (id: number, essayId: number) {
    if (!id || id <= 0) {
      return {
        data: null,
        success: false,
        message: "ID da redação é obrigatório e deve ser maior que zero.",
      };
    }

    try {
      const response = await privateApi.get(
        `/student_portal/private/processos/${id}/redacoes/${essayId}`
      );

      console.log("Response from API:", response.data);

      const validatedResponse = essayDetailResponseSchema.parse(response.data);

      return {
        data: validatedResponse.redacao,
        success: true,
      };
    } catch (error) {
      console.error(`Erro ao buscar redação com ID ${id}:`, error);

      if (error instanceof z.ZodError) {
        console.error("Schema validation error:", error.issues);
        return {
          data: null,
          success: false,
          message:
            "Estrutura de resposta da API inválida. Verifique o console para detalhes.",
        };
      }

      return {
        data: null,
        success: false,
        message:
          "Não foi possível carregar os detalhes da redação. Tente novamente mais tarde.",
      };
    }
  },
};

export function useGetEssayById(id: number | null, essayId: number) {
  return useQuery({
    queryKey: ["essay", id, essayId],
    queryFn: async () => {
      if (!id || id <= 0) {
        throw new Error(
          "ID da redação é obrigatório e deve ser maior que zero."
        );
      }
      return await EssayAPI.getById(id, essayId);
    },
    retry: (failureCount, error) => {
      if (error instanceof Error && error.message.includes("ID da redação")) {
        return false;
      }
      return failureCount < 2;
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    enabled: !!id && id > 0,
  });
}
